import { AgResourceLanguage } from '../types';
import { orderDetails as EnUsOrderDetails } from '../en-us/orderDetails';

export const orderDetails: AgResourceLanguage['orderDetails'] = {
  ...EnUsOrderDetails,
  returnBackButton: 'Terug naar Bestellingen',
  upcomingOrderDetails: {
    pageTitle: 'Abonnementsbestelling',
    orderDefaultStatus: 'Onbetaald',
    orderInformation: {
      orderDateLabel: 'Besteldatum',
      subscriptionNameLabel: 'Abonnement',
      statusLabel: 'Status',
      totalLabel: 'Totaal'
    },
    shipNowButton: 'Nu Verzenden',
    skipShipmentButton: 'Verzending Overslaan',
    changeDateButton: 'Besteldatum',
    subscriptionProductsList: 'Abonnementsproducten:',
    manageSubscriptionButton: 'Beheer Abonnement',
    emptyOrders: {
      title: 'Eenmalige Toevoegingen',
      description:
        'Shop het volledige assortiment AG1-producten en accessoires, exclusief beschikbaar voor leden.',
      buttonName: 'Voeg Product Toe aan Bestelling'
    },
    oneTimeField: {
      oneTimeProductsList: 'Eenmalige Toevoegingen',
      addProducrToOrderButton: 'Voeg Product Toe aan Bestelling',
      oneTimeSubtottal: 'Subtotaal Eenmalige Toevoegingen'
    }
  },
  pastOrdersDetails: {
    pageTitle: 'Bestelling',
    freeGiftTitle: 'Deel Gratis Pakketten',
    orderItems: 'Bestelitems',
    trackOrderButton: 'Volg Bestelling',
    subscriptionNameOTP: 'Eenmalige aankoop',
    defaultOrderStatus: 'Niet Beschikbaar',
    orderInformation: {
      orderDateLabel: 'Besteldatum',
      subscriptionNameLabel: 'Abonnement',
      statusLabel: 'Status',
      totalLabel: 'Totaal'
    }
  },
  missingValue: 'Niet Beschikbaar'
};
